import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

import { Util } from '../../utils/util';

@Component({
  selector: 'app-upload-many-files',
  templateUrl: './upload-many-files.component.html'
})
export class UploadManyFilesComponent {

  @Input() accept = '.pdf';
  @Input() form: FormGroup = new FormGroup({});
  @Input() name = '';
  @Output() update = new EventEmitter();

  constructor(private fb: FormBuilder) {}

  getOneFileName(item){
    return item.controls?.name?.value;
  }

  get documents(): FormArray{
    return this.form.get(this.name) as FormArray;
  }

  async onSelectFile(event) {
    const targetFiles = event.target.files;
    if (targetFiles) {
      for (const file of targetFiles) {
        if (file.type === `application/${this.accept.slice(1)}`) {
          this.documents.push( await this.createItem(file));
        }else {
          alert(`Não foi possível subir o arquivo ${file.name}`);
        }
      }
    }
    this.update.emit(null);
  }

  async createItem(file: File): Promise<FormGroup>{
    const object = {
      lastModified: file.lastModified,
      name: file.name,
      size: file.size,
      type: file.type,
      base64: await Util.fileToBase64(file)
    };
    return this.fb.group(object);
  }

  removeDocument(indice: number): void{
    this.documents.removeAt(indice);
  }

  downloadFromWeb(i) {
    const value = this.documents.controls[i].value;
    const downlodedFile = new Blob(Util.base64ToArrayBuffer(value.base64), {type: value.type});
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(downlodedFile);
    a.href = url;
    a.download = this.documents.controls[i].value.name;
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
}
